import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Heading2,
  Paragraph,
  List,
  Bold,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Let">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Alkoholfri &amp; Letøl</Heading1>
        </Col>
        <Col md={12} paddingTop="0px">
          <Paragraph>
            Letøl på fad finder du hos Skafte. De seneste år har letøl vundet mere og mere plads i danskernes hjerter og med god grund - letøl har nemlig den samme gode smag, som du kender fra almindelig øl, men har en meget lavere alkoholprocent. Gå på opdagelse i vores sortiment af letøl, der bl.a. byder på øl fra Herslev, Vestfyen og Platan. Du finder også alkoholfri fadøl her på siden.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelLetoel" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col md={12}>
          <Heading2>Letøl: den samme gode ølsmag - bare med lav alkoholprocent</Heading2>
          <Paragraph>
            Der kan være mange grunde til at droppe alkoholen. Det kan være graviditet, sygdom, et aktivt valg, et sundhedsmæssigt aspekt, at du skal køre hjem og mange andre årsager, der ligger til baggrund for dette. Uanset begrundelsen, kan det være skønt at nyde den friske og læskende smag af fadøl - og den får du i form af letøl eller alkoholfri fadøl hos Skafte.
          </Paragraph>
          <Paragraph>
            Når du sætter glasset med letøl til læberne og tager en slurk, kan du fornemme den samme perlende og forfriskende smag, som man ellers kender den fra mange andre øl. Den lave eller næsten helt manglende alkoholprocent påvirker nemlig ikke smagen, så den stadig kan genkendes og nydes på lige plan med øl, der har et almindeligt eller højt indhold af alkohol.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col md={12}>
          <Heading2>Alkoholfri øl og letøl er bedre end nogensinde</Heading2>
          <Paragraph>
            Hverken letøl eller alkoholfri fadøl er hvad det har været! Mange har tidligere været skræmt fra netop disse typer øl, da det har været svært at få smagen lige så god. De seneste år er teknikkerne dog blevet udviklet så meget, at der kun er minimal forskel i smagen, da det kun er alkoholen der mangler. Selve smagen af frisk og perlende letøl er i dag lige så forfriskende og lækker, som du kender den fra almindelig øl.
          </Paragraph>
          <Paragraph>
            Hvis du vælger en alkoholfri fadøl, kan du vide dig sikker på, at øllen kun har en alkoholprocent på 0,5% eller derunder, hvilket er lavere en de fleste lavalkoholiske ciders, der findes i supermarkederne.
            Der findes i dag mange metoder, hvorpå producenterne kan fjerne eller reducere alkolen i øllen og der tiløjes ofte ekstra humle, for at give en letøl eller alkoholfri fadøl samme gode fylde og krop.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col md={12}>
          <Heading2>Smag dig gennem vores udvalg af letøl på fad</Heading2>
          <Paragraph>
            Der kan være mange grunde til at vælge enten letøl, frem for almindelig eller klassisk øl med højere alkoholprocent. Uanset baggrunden for valget, behøver du absolut ikke at savne den gode smag af frisk og kold øl, der omsvøber tungen som et kærligt kram og slukker tørsten på en læskende og forfriskende måde.
          </Paragraph>
          <Paragraph>
            Hos Skafte finder du et skønt udvalg af både letøl og alkoholfri fadøl, herunder:
          </Paragraph>
          <List>
            <li>
              <Bold>Herslev Øko Landøl 2,7%:</Bold><br />
              Skøn letøl på fad med en alkoholprocent på kun 2,7%. Drikkevenlig letøl, der er inspireret af en gammel dansk og klassisk bondeøl og har en smuk rav farve. Letøllen er overgæret og brygget på store mængder malt, mens du mødes af en moderat bitterhed fra humlen. Denne letøl har en let og frugtig smag, grundet den tilsatte hø fra Herslev Bryghus’ egen økologiske mark.
            </li>
            <li>
              <Bold>Vestfyen Light:</Bold><br />
              En letøl, hvor du mødes af den klassiske smag af pilsner, men med en meget lavere alkoholprocent på kun 2,6%. Lever op til kategorien “letøl”, da den både er let i smagen, i promillen og i kalorierne. Lad dig ikke skræmme af den lave alkoholprocent, for selvom der er tale om en letøl, kan du stadig nyde den samme gode smag af pilsner, der er bevaret.
            </li>
            <li>
              <Bold>Platan Alkoholfri Pilsner:</Bold><br />
              Denne øl indeholder maksimalt 0,5% alkohol og må derfor gerne kategoriseres som værende alkoholfri, da den er så tæt på 0,0%. En velsmagende alkoholfri fadøl med en lækker smag af forfriskende pilsner.
            </li>
          </List>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
